// Helper to format axios/FastAPI error responses safely.
// Avoids React "Objects are not valid as a React child" crashes on validation errors.
export function formatApiErrorDetail(err, fallback = "Une erreur est survenue.") {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) =>
        e && typeof e === "object" && typeof e.msg === "string"
          ? e.msg
          : JSON.stringify(e),
      )
      .filter(Boolean)
      .join(" · ");
  }
  if (typeof detail === "object" && typeof detail.msg === "string") {
    return detail.msg;
  }
  return String(detail);
}
